import { render, staticRenderFns } from "./DeleteCompanyTypeConfirmation.vue?vue&type=template&id=06f203be"
import script from "./DeleteCompanyTypeConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteCompanyTypeConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports